/**
 * 获取富文本预览文本
 */
export function getRichTextPreview(html) {
  var reg = new RegExp('<.+?>', 'g');
  var regImg = new RegExp('<img.+?>', 'g');
  var regLink = new RegExp('<a.+?>(.+?)</a>', 'g');
  var msg = html.replace(regImg, '【图片】').replace(regLink, '$1').replace(reg, '');
  return msg;
}

/**
 * 获取富文本iframe预览文本
 */
export function getIframeRichPreview(html) {
  return `
    ${html}
  `;
}
